import { JobStatusTitle } from 'model/enum/JobStatusTitle';

export const getIsJobLive = (job) =>
  job?.status &&
  (job.status.title === JobStatusTitle.CREATED ||
    job.status.title === JobStatusTitle.IN_PROGRESS);
